export const ApplicationInfoConfig: Record<string, string>[] = [
  {
    key: "id",
    displayTitle: "Application Id"
  },
  {
    key: "status",
    displayTitle: "Application Status"
  },
  {
    key: "submittedDate",
    displayTitle: "Submitted date"
  },
  {
    key: "withdrawReason",
    displayTitle: "Withdrawn Reason"
  },
  {
    key: "lastUpdateBy",
    displayTitle: "Last Update by"
  },
  {
    key: "lastUpdated",
    displayTitle: "Last Updated Date"
  }
];

export const ApplicationMemberInfoConfig: Record<string, string>[] = [
  {
    key: "firstName",
    displayTitle: "First name"
  },
  {
    key: "lastName",
    displayTitle: "Last name"
  },
  {
    key: "id",
    displayTitle: "Employee id"
  },
  {
    key: "additionalEmployeeInfo.schoolName",
    displayTitle: "school name"
  },
  {
    key: "additionalEmployeeInfo.degree",
    displayTitle: "Degree"
  },
  {
    key: "additionalEmployeeInfo.concentration",
    displayTitle: "Concentration/Major"
  },
  {
    key: "additionalEmployeeInfo.linkedInUrl",
    displayTitle: "Linkedin"
  },
  {
    key: "additionalEmployeeInfo.portfolioUrl",
    displayTitle: "Portfolio"
  },
  {
    key: "additionalEmployeeInfo.githubUrl",
    displayTitle: "Github"
  },
  {
    key: "resumeUrl",
    displayTitle: "Resume Url"
  }
];

export const ApplicationJobInfoConfig: Record<string, string>[] = [
  {
    key: "jobInfo.jobTitle",
    displayTitle: "Job title"
  },
  {
    key: "jobId",
    displayTitle: "Job id"
  },
  {
    key: "jobInfo.totalPay",
    displayTitle: "Total pay"
  },
  {
    key: "jobInfo.jobRole",
    displayTitle: "Job role"
  },
  {
    key: "jobInfo.duration",
    displayTitle: "Job duration"
  },
  {
    key: "jobInfo.jobType",
    displayTitle: "Job type"
  },
  {
    key: "jobInfo.jobLevel",
    displayTitle: "Job level"
  },
  {
    key: "jobInfo.jobLocation",
    displayTitle: "Location"
  }
];
